// extracted by mini-css-extract-plugin
export default {"attendance":"PdjcouW9Ob8t5teCBBDk","pending":"mTEUb9BySA4abWLIjhJi","confirmed":"ZhL5jRiO7fsEqYOSXiEN","unpaid":"MAvm_wxIx4WVI9Yvpxqb"};